import { useTranslation } from "react-i18next";
import RobinPage from "../components/core/RobinPage";
import {
  DescriptionsProps,
  Descriptions,
  Button,
  Typography,
  Spin,
} from "antd";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ChangePasswordModal from "../components/ChangePasswordModal";
import { useGetMyUserQuery } from "../graphql/generated/hooks";

function Profile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [changePasswordModalVisible, setChangePasswordModalVisible] =
    useState(false);
  const { data, loading, refetch } = useGetMyUserQuery();

  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: "Name",
      children: data?.getMyUser?.name || "",
    },
    {
      key: "2",
      label: "Email",
      children: data?.getMyUser?.email || "",
    },
  ];

  return (
    <RobinPage
      title={t("title.profile")}
      actions={[
        {
          label: (
            <Typography.Link
              onClick={() => {
                refetch();
              }}
            >
              <FontAwesomeIcon icon={faRotateRight} />
            </Typography.Link>
          ),
        },
        {
          label: (
            <Button
              onClick={() => {
                setChangePasswordModalVisible(true);
              }}
            >
              {t("button.change_password")}
            </Button>
          ),
        },
        {
          label: (
            <Button
              onClick={() => {
                navigate(`/profile/update`);
              }}
            >
              {t("button.update_profile")}
            </Button>
          ),
        },
      ]}
    >
      {loading ? <Spin /> : <Descriptions items={items} />}
      <ChangePasswordModal
        isOpen={changePasswordModalVisible}
        close={() => {
          setChangePasswordModalVisible(false);
        }}
      />
    </RobinPage>
  );
}

export default Profile;
